import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../authentication/services/authentication.service';
import { canViewInvoices } from './tools/invoice-access.tools';

export const invoicesAccessGuard: CanActivateFn = () =>
  canViewInvoices(inject(AuthenticationService).getProfileState()) ||
  inject(Router).createUrlTree(['/wallet']);
